import { Injectable } from '@angular/core';
import { ConnectionHttpService, ApiResourceLocation } from '@softline/core';
import { PORTAL_REGISTRATION_CONFIRM_PATH, PORTAL_REGISTRATION_PATH } from '../registration.api';
import { UserRegistration } from '../data/user-registration.model';
import { Observable } from 'rxjs';
import { User } from '../../registration-admin/data/user.model';

@Injectable()
export class RegistrationResourceService {

  constructor(private service: ConnectionHttpService) {}

  register(user: UserRegistration): Observable<UserRegistration> {
    const location: ApiResourceLocation = { path: PORTAL_REGISTRATION_PATH };
    return this.service.create<UserRegistration, UserRegistration>(location, user);
  }

  confirm(username: string, hash: string): Observable<User> {
    const location: ApiResourceLocation = { path: PORTAL_REGISTRATION_CONFIRM_PATH };
    return this.service.create(location, {username, hash});
  }
}
